import { generateRootObjectSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";
import { ButtonParticleSpec } from "components/cards/particles/YinzCam";

export const specification = new BaseAtomSpec("Button Card", generateRootObjectSchema({
  container: generateAtomContainerSchema(),
  button: ButtonParticleSpec.generateSchema("Button", "The button."),
}));
